import React from 'react';
import axios from 'axios';
import FontAwesome from 'react-fontawesome';
import {Form, InputGroup, FormGroup, FormControl, ControlLabel, HelpBlock, Button} from 'react-bootstrap';
import {withRouter} from "react-router-dom";

import Loading from "../../components/Loading/index";

import './style.css';

class AdminForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            inProcess: false,
            loading: this.props.match.params.id ? true : false,
            values: {
                email: '',
                firstname: '',
                surname: '',
                nickname: '',
                phoneNumber: '',
                password: '',
                password2: ''
            },
            validation: {
                states: {
                  email: null,
                  password: null,
                  firstname: null,
                  surname: null,
                  nickname: null,
                  phoneNumber: null
                },
                messages: {
                  email: '',
                  password: '',
                  firstname: '',
                  surname: '',
                  nickname: '',
                  phoneNumber: ''
                }
            }
        };

        this.handleChangeEmail = this.handleChangeEmail.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.handleChangePassword2 = this.handleChangePassword2.bind(this);
        this.handleChangeFirstname = this.handleChangeFirstname.bind(this);
        this.handleChangeSurname = this.handleChangeSurname.bind(this);
        this.handleChangeNickname = this.handleChangeNickname.bind(this);
        this.handleChangePhoneNumber = this.handleChangePhoneNumber.bind(this);

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentDidMount() {
        this.getAdmin();
    }

    getAdmin(){
        if (this.props.match.params.id) {
            let loginToken = this.props.sessionData.accessToken;
            let config = {
                headers: {
                    'Authorization': 'Bearer ' + loginToken
                }
            };
            axios.get(this.props.api.users + "/" + this.props.match.params.id, config)
            .then((response) => {
                if (!this._calledComponentWillUnmount) {
                    this.setState({
                        values: {
                            ...this.state.values,
                            ...response.data,
                            password: '',
                            password2: ''
                        },
                        loading: false
                    });
                }
            }).catch((error) => {
                this.props.addNotification('error', error.response.status, 'Nepodařilo se načíst administrátora!');
                this.props.history.push('/Admins');
                console.log("Axios error: ", error);
            });
        }
    }

    handleChangeEmail(event) {
        let email =  event ? event.target.value : this.state.values.email;
        let values = this.state.values;
        values.email = email;
        let validation = this.state.validation;
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (re.test(email)) {
            validation.states.email = "success";
            validation.messages.email = '';
        } else {
            validation.states.email = "error";
            validation.messages.email = 'E-mail nesplňuje formát! Příklad: uzivatel@domena.cz';
        }
        this.setState({
            values,
            validation
        });
    }

    handleChangePassword(event) {
        let password =  event ? event.target.value : this.state.values.password;
        let values = this.state.values;
        values.password = password;
        this.validatePassword();
        this.setState({
            values
        });
    }

    handleChangePassword2(event) {
        let password2 =  event ? event.target.value : this.state.values.password2;
        let values = this.state.values;
        values.password2 = password2;
        this.validatePassword();
        this.setState({
            values
        });
    }

    handleChangeFirstname(event) {
        let firstname =  event ? event.target.value : this.state.values.firstname;

        let values = this.state.values;
        values.firstname = firstname;

        let validation = this.state.validation;
        validation.states.firstname = firstname === '' ? 'error' : 'success';
        validation.messages.firstname = firstname === '' ? 'Jméno musí být vyplněno!' : '';

        this.setState({
            values,
            validation
        });
    }

    handleChangeSurname(event) {
        let surname =  event ? event.target.value : this.state.values.surname;

        let values = this.state.values;
        values.surname = surname;

        let validation = this.state.validation;
        validation.states.surname = surname === '' ? 'error' : 'success';
        validation.messages.surname = surname === '' ? 'Příjmení musí být vyplněno!' : '';

        this.setState({
            values
        });
    }

    handleChangeNickname(event) {
        let nickname =  event ? event.target.value : this.state.values.nickname;

        let values = this.state.values;
        values.nickname = nickname;

        this.setState({
            values
        });
    }

    handleChangePhoneNumber(event) {
        let phoneNumber =  event ? event.target.value : this.state.values.phoneNumber;

        let values = this.state.values;
        values.phoneNumber = phoneNumber;

        let validation = this.state.validation;
        let length = (phoneNumber.replace(/ +/g, '')).length;
        let re = /(\+[0-9]{3}[ ]?)?[0-9]{3}[ ]?[0-9]{3}[ ]?[0-9]{3}/;

        if (phoneNumber !== '') {
            if (re.test(phoneNumber) && (length === 9 || length === 13)) {
                validation.states.phoneNumber = "success";
                validation.messages.phoneNumber = '';
            } else {
                validation.states.phoneNumber = "error";
                validation.messages.phoneNumber = 'Číslo nesplňuje formát! Číslo může být s příponou i bez, s mezerami i bez mezer.'
            }
        }

        this.setState({
            values,
            validation
        });
    }

    validatePassword(){
        let password = this.state.values.password;
        let password2 = this.state.values.password2;

        let validation = this.state.validation;

        if (password === '' || password.length < 6) {
            validation.states.password = 'error';
            validation.messages.password = 'Heslo musí být vyplněno a musí mít alespoň 6 znaků!';
            return false;
        }

        if (password2 === '' || password2.length < 6) {
            validation.states.password = 'error';
            validation.messages.password = 'Heslo znovu musí být vyplněno a musí mít alespoň 6 znaků!!';
            return false;
        }

        if (password !== password2) {
            validation.states.password = 'error';
            validation.messages.password = 'Hesla se neshodují!';
            return false;
        }

        validation.states.password = 'success';
        validation.messages.password = '';
        return true;
    }

    isValid() {
        this.handleChangeEmail();
        this.handleChangeFirstname();
        this.handleChangeSurname();
        if (!this.props.match.params.id) this.validatePassword();
        return Object.values(this.state.validation.states).indexOf('error') < 0;
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this.isValid()) {
            this.props.action(this.state.values);
            this.setState({inProcess: true});
        }
    }

    handleClose() {
        this.props.history.push('/admins');
    }

    render() {
        let title = this.props.data ? this.props.title + ": " + this.props.data.firstname + " " + this.props.data.surname : this.props.title;
        let {email, firstname, surname, nickname, phoneNumber, password, password2} = this.state.values;
        let {states, messages} = this.state.validation;
        return (
            <div className="x-panel">
                <div className="x-title">
                    <h2>{title}</h2>
                    <div className="clearfix"/>
                </div>
                <div className="x-content">
                    {
                        this.state.loading ? <Loading/> :
                            <Form onSubmit={this.handleSubmit}>
                                <div className="col-md-offset-3 col-sm-offset-3 col-md-6 col-sm-6 col-xs-12">
                                    <FormGroup controlId="email" validationState={states.email}>
                                        <ControlLabel>Email <span className="required">*</span></ControlLabel>
                                        <InputGroup>
                                            <InputGroup.Addon><FontAwesome name="at"/></InputGroup.Addon>
                                            <FormControl type="text" value={email} onChange={this.handleChangeEmail} />
                                            <FormControl.Feedback />
                                        </InputGroup>
                                        <HelpBlock>{messages.email}</HelpBlock>
                                    </FormGroup>
                                    <FormGroup controlId="password" validationState={states.password}>
                                        <ControlLabel>Heslo <span className="required">*</span></ControlLabel>
                                        <InputGroup>
                                            <InputGroup.Addon><FontAwesome name="key"/></InputGroup.Addon>
                                            <FormControl type="password" value={password} onChange={this.handleChangePassword}/>
                                            <FormControl.Feedback />
                                        </InputGroup>
                                        <HelpBlock>{messages.password}</HelpBlock>
                                    </FormGroup>
                                    <FormGroup controlId="password" validationState={states.password}>
                                        <ControlLabel>Heslo znovu <span className="required">*</span></ControlLabel>
                                        <InputGroup>
                                            <InputGroup.Addon><FontAwesome name="key"/></InputGroup.Addon>
                                            <FormControl type="password" value={password2} onChange={this.handleChangePassword2}/>
                                            <FormControl.Feedback />
                                        </InputGroup>
                                        <HelpBlock>{messages.password}</HelpBlock>
                                    </FormGroup>
                                    <FormGroup controlId="firstname" validationState={states.firstname}>
                                        <ControlLabel>Jméno <span className="required">*</span></ControlLabel>
                                        <FormControl type="text" value={firstname} onChange={this.handleChangeFirstname}/>
                                        <HelpBlock>{messages.firstname}</HelpBlock>
                                        <FormControl.Feedback />
                                    </FormGroup>
                                    <FormGroup controlId="surname" validationState={states.surname}>
                                        <ControlLabel>Příjmení <span className="required">*</span></ControlLabel>
                                        <FormControl type="text" value={surname} onChange={this.handleChangeSurname}/>
                                        <HelpBlock>{messages.surname}</HelpBlock>
                                        <FormControl.Feedback />
                                    </FormGroup>
                                    <FormGroup controlId="nickname" validationState={states.nickname}>
                                        <ControlLabel>Přezdívka</ControlLabel>
                                        <FormControl type="text" value={nickname} onChange={this.handleChangeNickname}/>
                                        <HelpBlock>{messages.nickname}</HelpBlock>
                                        <FormControl.Feedback />
                                    </FormGroup>
                                    <FormGroup controlId="phoneNumber" validationState={states.phoneNumber}>
                                        <ControlLabel>Telefon</ControlLabel>
                                        <FormControl type="text"  value={phoneNumber} onChange={this.handleChangePhoneNumber}/>
                                        <HelpBlock>{messages.phoneNumber}</HelpBlock>
                                        <FormControl.Feedback />
                                    </FormGroup>
                                </div>
                                <div className="clearfix"/>
                                <div className="ln-solid"/>
                                <FormGroup>
                                    <div className="col-md-4 col-sm-4 col-xs-12 col-md-offset-4">
                                        <Button className="btn-primary" type="button" onClick={this.handleClose}>Zpět</Button>
                                        <Button type="submit" disabled={this.state.inProcess} className="btn btn-success">{this.props.button}</Button>
                                        {this.state.inProcess && <Loading/>}
                                    </div>
                                </FormGroup>
                            </Form>
                    }
                </div>
            </div>
        );
    }
}

export default withRouter(AdminForm);



/** WEBPACK FOOTER **
 ** ./src/containers/Admins/AdminForm.js
 **/